'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.deck.gce.autoscalingPolicy.basicSettings.component', [])
  .component('gceAutoscalingPolicyBasicSettings', {
    bindings: {
      policy: '='
    },
    templateUrl: require('./basicSettings.component.html')
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/google/src/autoscalingPolicy/components/basicSettings/basicSettings.component.js